import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';
import { ShortcutEventOutput, ShortcutInput } from "ng-keyboard-shortcuts";
import { locale as danish } from './translate/ds';
import { locale as english } from './translate/en';

@Component({
    selector: 'app-alert-message-model',
    templateUrl: './alert-message-model.component.html',
    styles: []
})
export class AlertMessageModelComponent implements OnInit {
    Header: string = "";
    Replace: any = {};
    showOKButton: Boolean = false;
    shortcuts: ShortcutInput[] = [];
    showManualButton: boolean = false;
    showDatePicker: boolean = false;
    billDate: Date = new Date();
    constructor(private translationLoader: FuseTranslationLoaderService,
        public dialogRef: MatDialogRef<AlertMessageModelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.translationLoader.loadTranslations(english, danish);

    }

    ngOnInit() {
        this.Header = this.data.Header;
        this.Replace = this.data.Replace || {};
        this.showOKButton = this.data.ShowOKButton;
        this.showManualButton = this.data.ShowManualButton;
        this.billDate = this.data.BillDate;
        if (this.data.ShowDatePicker == true) {
            this.showDatePicker = this.data.ShowDatePicker;
        }
    }

    onCloseDialog(e) {
        if (this.showDatePicker)
            this.dialogRef.close({ value: e ? true : false, billDate: this.billDate });
        else
            this.dialogRef.close(e ? true : false)
    }

    onFocusIn(event) {
        event.model.show();
    }

    addManually(value) {
        this.dialogRef.close(value);
    }

    ngAfterViewInit() {
        this.shortcuts.push(
            {
                key: ["j"],
                label: "Ja",
                description: "j",
                command: (output: ShortcutEventOutput) => {
                    this.dialogRef.close(true);
                },
                preventDefault: true
            },
            {
                key: ["n"],
                label: "Nej",
                description: "n",
                command: (output: ShortcutEventOutput) => {
                    this.dialogRef.close(false)
                },
                preventDefault: true
            }
        );
    }

}
